import { render, staticRenderFns } from "./WonderStrategyDetail.vue?vue&type=template&id=35d8bba7&scoped=true"
import script from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
export * from "./WonderStrategyDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderStrategyDetail.vue?vue&type=style&index=0&id=35d8bba7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8bba7",
  null
  
)

export default component.exports